import React, { useEffect } from 'react'
import { Col, Container, Row, Table, Button } from 'react-bootstrap'
import LogoQualy from '../../Components/LogoQualy'
import { useLocation } from 'react-router'
import MainNav from '../../Components/Navbar'
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'

function ImpressaoPresenca() {
    const { state } = useLocation()

    const emp = state?.company
    const dep = state?.department
    const roll = state?.roll
    const dateTime = state?.dateTime
    const print = state?.print ?? "false"

    const exportToExcel = async () => {
        const workbook = new ExcelJS.Workbook()
        const worksheet = workbook.addWorksheet('Chamada')

        const sortedEmployees = roll?.employees ?
            [...roll.employees].sort((a, b) => a.employee.localeCompare(b.employee)) : []

        const azulEscuro = 'FF1f4e79'
        const branco = 'FFFFFFFF'

        if (sortedEmployees.length > 0) {
            const empresaCell = worksheet.getCell('A1')
            empresaCell.value = 'Empresa: ' + emp;
            empresaCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: azulEscuro } }
            empresaCell.font = { name: 'Arial', size: 10, bold: true, color: { argb: branco } }
            empresaCell.alignment = { vertical: 'middle', horizontal: 'left' }

            const dataCell = worksheet.getCell('B1')
            dataCell.value = 'Data: ' + extractDateOrTime(dateTime, true);
            dataCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: azulEscuro } }
            dataCell.font = { name: 'Arial', size: 10, bold: true, color: { argb: branco } }
            dataCell.alignment = { vertical: 'middle', horizontal: 'left' }

            const depCell = worksheet.getCell('A2')
            depCell.value = `Departamento: ${dep}`
            depCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: azulEscuro } }
            depCell.font = { name: 'Arial', size: 10, bold: true, color: { argb: branco } }
            depCell.alignment = { vertical: 'middle', horizontal: 'left' }

            const horaCell = worksheet.getCell('B2')
            horaCell.value = `Hora: ${extractDateOrTime(dateTime, false)}`
            horaCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: azulEscuro } }
            horaCell.font = { name: 'Arial', size: 10, bold: true, color: { argb: branco } }
            horaCell.alignment = { vertical: 'middle', horizontal: 'left' }

            const colabCell = worksheet.getCell('A3')
            colabCell.value = 'Colaborador'
            colabCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: azulEscuro } }
            colabCell.font = { name: 'Arial', size: 10, bold: true, color: { argb: branco } }
            colabCell.alignment = { vertical: 'middle', horizontal: 'center' }

            const statusCell = worksheet.getCell('B3')
            statusCell.value = 'Status'
            statusCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: azulEscuro } }
            statusCell.font = { name: 'Arial', size: 10, bold: true, color: { argb: branco } }
            statusCell.alignment = { vertical: 'middle', horizontal: 'center' }

            worksheet.getColumn(1).width = 30
            worksheet.getColumn(2).width = 15
            const contagem = { P: 0, A: 0, F: 0 }
            const total = sortedEmployees.length

            sortedEmployees.forEach((emp, index) => {
                const status = (emp.status || '').toUpperCase()
                let valorCelula = ''
                let corDeFundo = null
                let corFonte = 'FF000000'

                if (status === 'PRESENTE') {
                    valorCelula = 1
                    corDeFundo = azulEscuro
                    corFonte = branco
                    contagem.P++
                } else if (status === 'AUSENTE') {
                    contagem.A++
                } else if (status === 'FALTA') {
                    contagem.F++
                }

                const rowIndex = 4 + index
                const row = worksheet.getRow(rowIndex)
                row.getCell(1).value = emp.employee
                row.getCell(2).value = valorCelula

                row.getCell(1).font = {
                    name: 'Arial',
                    size: 10,
                    color: { argb: 'FF000000' },
                }
                row.getCell(1).alignment = { vertical: 'middle', horizontal: 'left' }

                row.getCell(2).font = {
                    name: 'Arial',
                    size: 10,
                    color: { argb: corFonte }
                }
                row.getCell(2).alignment = { vertical: 'middle', horizontal: 'center' }

                if (corDeFundo) {
                    row.getCell(2).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: corDeFundo }
                    }
                }

                row.eachCell(cell => {
                    cell.border = {
                        top: { style: 'thin', color: { argb: 'FF000000' } },
                        left: { style: 'thin', color: { argb: 'FF000000' } },
                        bottom: { style: 'thin', color: { argb: 'FF000000' } },
                        right: { style: 'thin', color: { argb: 'FF000000' } }
                    }
                })
            })

            const linhaInicio = 4
            const linhaFim = linhaInicio + total - 1
            const intervaloStatus = `B${linhaInicio}:B${linhaFim}`

            worksheet.addRow([])

            const resumo = [
                ['TOTAL PRESENTES', { formula: `COUNTIF(${intervaloStatus}, 1)` }, { formula: `TEXT(COUNTIF(${intervaloStatus}, 1)/${total}, "0%")` }],
                ['TOTAL FALTAS + AUSENTES', { formula: `COUNTBLANK(${intervaloStatus})` }, { formula: `TEXT(COUNTBLANK(${intervaloStatus})/${total}, "0%")` }]
            ]

            resumo.forEach(([label, formulaValor, formulaPercent]) => {
                const row = worksheet.addRow([label, null, null])
                row.getCell(2).value = formulaValor
                row.getCell(3).value = formulaPercent

                row.eachCell(cell => {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: azulEscuro }
                    }
                    cell.font = {
                        bold: true,
                        color: { argb: branco },
                        name: 'Arial',
                        size: 10
                    }
                    cell.alignment = { vertical: 'middle', horizontal: 'center' }
                    cell.border = {
                        top: { style: 'thin', color: { argb: 'FF000000' } },
                        left: { style: 'thin', color: { argb: 'FF000000' } },
                        bottom: { style: 'thin', color: { argb: 'FF000000' } },
                        right: { style: 'thin', color: { argb: 'FF000000' } }
                    }
                })
            })

        } else {
            worksheet.columns = [
                { header: 'Total de Pessoas', key: 'total', width: 20 },
                { header: 'Presentes', key: 'presentes', width: 20 }
            ]

            const headerRow = worksheet.getRow(1)
            headerRow.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: azulEscuro }
                }
                cell.font = {
                    bold: true,
                    color: { argb: branco },
                    name: 'Arial',
                    size: 10
                }
                cell.alignment = { vertical: 'middle', horizontal: 'center' }
                cell.border = {
                    top: { style: 'thin', color: { argb: 'FF000000' } },
                    left: { style: 'thin', color: { argb: 'FF000000' } },
                    bottom: { style: 'thin', color: { argb: 'FF000000' } },
                    right: { style: 'thin', color: { argb: 'FF000000' } }
                }
            })

            const dataRow = worksheet.addRow({
                total: roll?.totalofPeople ?? 'N/A',
                presentes: roll?.presentPeople ?? 'N/A'
            })

            dataRow.eachCell(cell => {
                cell.font = {
                    name: 'Arial',
                    size: 10
                }
                cell.alignment = { vertical: 'middle', horizontal: 'center' }
                cell.border = {
                    top: { style: 'thin', color: { argb: 'FF000000' } },
                    left: { style: 'thin', color: { argb: 'FF000000' } },
                    bottom: { style: 'thin', color: { argb: 'FF000000' } },
                    right: { style: 'thin', color: { argb: 'FF000000' } }
                }
            })
        }

        worksheet.eachRow(row => {
            row.height = 15
        })

        const buffer = await workbook.xlsx.writeBuffer()
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        saveAs(blob, `Presenca_${emp}_${dep}.xlsx`)
    }

    useEffect(() => {
        handlePrint()
    }, [])

    const handlePrint = () => {
        if (print) {
            window.print()
        }
    }

    const tableRowStyle = {
        paddingTop: "2px",
        paddingBottom: "2px"
    }

    const extractDateOrTime = (input, returnDate) => {
        if (input instanceof Date && !isNaN(input.getTime())) {
            return input.toLocaleDateString() + input.toLocaleTimeString()
        }

        const [day, month, year, time] = input.split("-")
        return returnDate ? `${day}/${month}/${year}` : time
    }

    return (
        <>
            <div className="d-print-none">
                <MainNav />
            </div>
            <Container className="mt-4" fluid={print}>
                <div className="d-flex justify-content-between my-3">
                    <div>
                        <h4 className="mb-0">Relatório de Presença</h4>
                        <small><strong>Empresa:</strong> {emp} | <strong>Departamento:</strong> {dep}</small><br />
                        <small><strong>Data original da chamada:</strong> {extractDateOrTime(dateTime, true)} | <strong>Hora do registro da chamada:</strong> {extractDateOrTime(dateTime)}</small>
                    </div>
                    <div className="mb-3 text-end">
                        <Button onClick={exportToExcel}>Exportar XSLX</Button>
                    </div>
                </div>

                {roll?.employees && roll.employees.length > 0 ? (
                    <Table striped bordered hover={!print}>
                        <thead>
                            <tr>
                                <th>Funcionário</th>
                                <th>Status</th>
                                <th>Observação</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[...roll.employees]
                                .sort((a, b) => a.employee.localeCompare(b.employee))
                                .map((emp, index) => (
                                    <tr key={index} className='py-0 my-0'>
                                        <td style={tableRowStyle}>{emp.employee}</td>
                                        <td style={tableRowStyle}>{emp.status}</td>
                                        <td style={tableRowStyle}>
                                            {emp.additionalInfo
                                                ? `${emp.additionalInfo} (${emp.daysOffBeginning || '-'} - ${emp.daysOffEnding || '-'})`
                                                : '-'}
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </Table>
                ) : (
                    <Table striped bordered hover={!print}>
                        <thead>
                            <tr>
                                <th>Total de Pessoas</th>
                                <th>Total Presentes</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={tableRowStyle}>{roll?.totalofPeople ?? 'N/A'}</td>
                                <td style={tableRowStyle}>{roll?.presentPeople ?? 'N/A'}</td>
                            </tr>
                        </tbody>
                    </Table>
                )}
            </Container>
        </>
    )
}

export default ImpressaoPresenca
